import { ContactsTable } from "components";
import ContactDrawer from "components/Contacts/ContactDrawer";
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';


const Contacts = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [drawerMode, setDrawerMode] = useState('edit');
    const [selectedContactId, setSelectedContactId] = useState(null);

    useEffect(() => {
        const editId = searchParams.get('editId');
        const viewId = searchParams.get('viewId');
        const createNew = searchParams.get('create');

        if (editId) {
            setSelectedContactId(editId);
            setDrawerMode('edit');
            setDrawerVisible(true);
        } else if (viewId) {
            setSelectedContactId(viewId);
            setDrawerMode('view');
            setDrawerVisible(true);
        } else if (createNew === 'true') {
            setSelectedContactId(null);
            setDrawerMode('edit');
            setDrawerVisible(true);
        } else {
            setDrawerVisible(false);
        }
    }, [searchParams]);

    const handleDrawerClose = () => {
        setDrawerVisible(false);
        setSelectedContactId(null);
        // Drop only the drawer params; the list's search/page stay in the URL.
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            ['editId', 'viewId', 'create'].forEach((key) => params.delete(key));
            return params;
        });
    };

    const handleDrawerSuccess = () => {
        // Trigger a refresh of the contacts table
        window.location.reload();
    };

    return (
        <>
            <ContactsTable />
            <ContactDrawer
                visible={drawerVisible}
                onClose={handleDrawerClose}
                contactId={selectedContactId}
                mode={drawerMode}
                onSuccess={handleDrawerSuccess}
            />
        </>
    );

}
export default Contacts;